import API from "./API";

export default class GalleryDAO {
    static getGalleryByItemId = async (id) => {
        return await API.request(`/v1/item_gallery/item/${id}`, "GET");
    }


}